//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================
 
// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
 
const response = () => {
  const { handleResponse, handleError } = HandleApiResponse();
  async function getsignature(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/get-startup?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }
 
  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/search?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function filter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function getPending(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/get-pending?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }
  async function salesRepRejectAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
  
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/reject-enrollment`,
        obj
      );
  
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  
  async function searchPending(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/searchPending?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function getstartupLogs(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/startup-enrollment-logs?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function salesRepMappingApi(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
 
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/sales-rep-mapping`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function billingConfirmationApi(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
 
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/billing-confirmation`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function addOnPlansMappingApi(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
 
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/add-on-plans-mapping`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function enrollmentExport(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/enrollment-export?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
 async function upload(values) {
    try {
        const obj = {
            method: "POST",
            credentials: "include",
            body: values,
        };

        const res = await fetch(
            `${config.host}/cdr-panel/thrive-startup/upload`, // ← use backticks here
            obj
        );

        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
}

async function getbillingrecord(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/billing-record-enrollment?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function billingdateenrollment(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values),
      };
  
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/billing-datesetting-enrollment`,
        obj
      );
  
      // Optional: Safety check before handling
      if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
  
      return handleResponse(res);
    } catch (err) {
      return handleError(err); // Ensure error is passed along
    }
  }

   async function billingenrollmentsearchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-startup/billing-record-enrollment-search?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getaddplanrecord(values) {
      try {
        const obj = {
          method: "GET",
          credentials: 'include',
          headers: {
            "Content-Type": "application/json"
          },
        };
        let query = JSON.stringify(values);
        let res = await fetch(
          `${config.host}/cdr-panel/thrive-startup/addplan-record-enrollment?query=${query}`,
          obj
        );
        return handleResponse(res);
      }
      catch (err) {
        handleError(err);
      }
    }
  
     async function addplanenrollmentsearchAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
        };
        let query;
        query = JSON.stringify(values);
        let res = await fetch(
          `${config.host}/cdr-panel/thrive-startup/addplan-record-enrollment-search?query=${query}`,
          obj
        );
   
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }
 
 
  return {
    getsignature,
    searchAPI,
    filter,
    getPending,
    searchPending,
    getstartupLogs,
    salesRepMappingApi,
    billingConfirmationApi,
    addOnPlansMappingApi,
    enrollmentExport,
    salesRepRejectAPI,
    upload,
    getbillingrecord,
    billingdateenrollment,
    billingenrollmentsearchAPI,
    getaddplanrecord,
    addplanenrollmentsearchAPI
  };
};
 
export default response;
 
 